import { render } from "./ModalSuccessSendInvoice.vue?vue&type=template&id=507bf207&scoped=true&ts=true"
import script from "./ModalSuccessSendInvoice.vue?vue&type=script&lang=ts"
export * from "./ModalSuccessSendInvoice.vue?vue&type=script&lang=ts"

import "./ModalSuccessSendInvoice.vue?vue&type=style&index=0&id=507bf207&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507bf207"]])

export default __exports__